import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=ca436d4e"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=ca436d4e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca436d4e')) {
      api.createRecord('ca436d4e', component.options)
    } else {
      api.reload('ca436d4e', component.options)
    }
    module.hot.accept("./profile.vue?vue&type=template&id=ca436d4e", function () {
      api.rerender('ca436d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/profile/profile.vue"
export default component.exports